module.exports = new __parcel__URL__("witch.73ebae6b.webp").toString();